<template>
  <div class="user-agreement">
    <div class="agreement-container">
      <div class="agreement-title">用户协议</div>
      <div class="agreement-content">
        <div class="content-main">
          <p>欢迎您与因朔桔（上海）智能科技有限公司(以下简称"本公司"或"因朔桔商城")共同签署《用户协议》。本协议详述您在因朔桔商城平台（指https://mujihealth.com.cn/pc/mall的互联网网站及其小程序软件、应用程序等）使用因朔桔商城服务享受的权益和所须遵守的条款和条件。</p>

          <p><strong>1、服务条款的确认和接纳</strong></p>
          <p>1.1您成为因朔桔商城用户前，必须阅读、同意并接受本协议中所含的所有条款和条件，特别是以加粗或下划线形式提示您注意的条款。本协议在用户接受注册时生效。因朔桔商城规则、说明、公告和隐私权政策也是本协议不可分割的一部分，如您继续使用因朔桔商城服务，视为您同意，并受其约束。因朔桔商城建议您阅读本协议时，也应阅读本文件所提及的其他网页中所包含的资料，因为其可能包含对作为因朔桔商城用户的您适用的进一步条款和条件。</p>

          <p>1.2因朔桔商城可能根据实际情况随时通过在因朔桔商城平台上公布经修订的条款。所有经修订的条款将按照法律规定自其网站进行公示，并载明生效日期。如您不同意该等修订，您必须终止您与因朔桔商城的用户关系，修订条款对您不产生效力。如您在修订条款生效后仍继续使用因朔桔商城，即视为知悉变动内容并同意接受。</p>

          <p>1.3因朔桔商城的服务仅向适用法律下能够签订具有法律约束力的合同的个人提供并仅由其使用。在不限制前述规定的前提下，因朔桔商城的服务不向18周岁以下或被临时或无限期中止使用因朔桔商城服务的用户提供。在电子商务活动中我们推定您具有相应的民事行为能力，如您不合资格，请勿使用因朔桔商城的服务。</p>

          <p>1.4当您完成注册后，您可获得因朔桔商城平台账户，您的账户密码由您自行设置并由您保管，请务必保管好您的账户。凡经您的账户和密码成功登录使用因朔桔商城平台，即视为您的使用行为。账户因您主动泄露、出借或因您遭受他人攻击、诈骗等行为导致的损失及后果，因朔桔商城并不承担责任。</p>

          <p>1.5您接受并认可因朔桔商城对您购买行为的判定，同时请您理解判定规则涉及因朔桔商城的核心商业秘密，如若判定数据和逻辑被公开，会被恶意利用进行规避，损害因朔桔商城以及其他活动参与方的利益，因此因朔桔商城对判定规则不予以公开。</p>

          <p>1.6为了提升用户体验、增加服务内容，因朔桔商城将不断推出新的服务，因朔桔商城有权主动对软件进行更新或版本升级，更新或版本升级后，用户在下次登录使用时需要下载、安装并使用最新版本。如您未能下载、安装并使用最新版本，视为您放弃提升用户体验或增加服务内容。</p>

          <p><strong>2、订单、价格和数量</strong></p>
          <p>2.1使用因朔桔商城下订单，您应具备购买相关商品的权利能力和行为能力，在下订单的同时，即视为您满足前述条件，并对您在订单中提供的所有信息的真实性负责。如您不具备前述与您行为相适应的权利能力和行为能力，则您与您的监护人应依照法律规定及本协议约定承担一切后果。</p>

          <p>2.2当您作为消费者为生活消费需要下单并支付货款的情况下，您货款支付成功后即视为您与销售商之间就已支付货款部分的订单建立了合同关系。如您与销售商有特殊约定的，以特殊约定为准。</p>

          <p>2.3在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。</p>

          <p>2.4因朔桔商城将尽最大努力保证您所购商品与网站上公布的价格一致，但价目表和声明并不构成要约。同时，因朔桔商城保留对产品订购的数量等的限制权。本网站无法完全避免您提交的订单信息中的商品出现缺货、价格标示错误等情况；如您下单所购买的商品出现该等情况，您有权取消订单。</p>

          <p>2.5产品的价格和可获性都在因朔桔商城上指明。这类信息将随时更改且不发任何通知。如无特殊说明，商品的价格是含税价。如果发生了意外情况，在确认了您的订单后，由于税额变化引起的价格变化，或是由于网站的错误或重大误解等造成商品价格变化，您有权取消您的订单。</p>

          <p>2.6您理解并同意：您的购买行为应当基于真实的消费需求，不得存在对商品及/或服务实施虚假交易等扰乱因朔桔商城平台正常交易秩序的行为，否则将被认定为违约。</p>

          <p>2.7您理解并同意：为让更多用户享受优惠福利，同时降低恶意购买的风险，可能会对同一用户的参与资格、次数以及购买数量、次数进行限制，具体以商品或活动页面显示为准。如您违反限制性要求，则因朔桔商城有权采取取消订单、撤销资格、收回奖励等一项或多项处理措施且无须承担任何责任。</p>

          <p><strong>3、送货、费用</strong></p>
          <p>3.1因朔桔商城将会把产品送到您所指定的送货地址。所有在因朔桔商城上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。送货费用根据您选择的配送方式及/或因朔桔商城的规定不同而异。</p>

          <p>3.2请清楚准确地填写您的真实姓名、送货地址、收货人及联系方式。因如下情况造成订单延迟、错误交付或无法配送等，因朔桔商城将不承担责任：</p>

          <p>3.2.1客户提供错误信息和不详细的地址；</p>

          <p>3.2.2货物送达无人签收，由此造成的重复配送所产生的费用及相关的后果；</p>

          <p>3.2.3不可抗力，例如：自然灾害、恶劣天气、交通戒严、罢工、恐怖事件、突发战争等。</p>

          <p><strong>4、对用户信息的存储和限制</strong></p>
          <p>因朔桔商城有判定用户的行为是否符合因朔桔商城服务条款的要求和精神的保留权利，如果用户违背了服务条款的规定，因朔桔商城有中断对其提供网络服务的权利。</p>

          <p><strong>5、用户管理</strong></p>
          <p>5.1因朔桔商城平台账户、联系方式、终端设备、IP地址、收货地址、收货人信息等与消费者身份相关的信息，其中任意一项或数项存在相同、相似、或通过特定标记形成批量信息的均认定为同一用户。</p>

          <p>5.2用户单独承担发布内容的责任。用户对服务的使用是根据所有适用于因朔桔商城的国家法律、地方法律和国际法律标准。用户必须遵循：</p>

          <p>5.2.1从中国境内向外传输技术性资料时必须符合中国有关法规；</p>

          <p>5.2.2使用网络服务不作非法用途；</p>

          <p>5.2.3不干扰或混乱网络服务。不对因朔桔商城相关软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现源代码或采取黑客、木马等方式侵害软件正常运营或后台数据；</p>

          <p>5.2.4遵守所有使用网络服务的网络协议、规定、程序和惯例；</p>

          <p>5.2.5不得使用外挂和因朔桔商城平台漏洞来获得不正当的利益；</p>

          <p>5.2.6不得在因朔桔商城平台中内置各种插件程序或者其他的第三方程序。</p>

          <p class="indent">5.2 用户须对在因朔桔商城的注册信息的真实性、合法性、有效性承担全部责任。</p>
          <p class="indent">5.3 用户须承诺不传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽等信息资料。另外，用户也不能传输和教唆他人构成犯罪行为的资料；不能传输反对宪法所确定的基本原则、泄露国家秘密、颠覆国家政权、破坏国家统一和危害国家安全的资料；不能散布谣言，扰乱社会秩序，破坏社会稳定的；不能传输任何不符合当地法规、国家法律和国际法律的资料。</p>
          <p class="indent">5.4 用户须承诺严格遵守法律法规的规定及因朔桔商城的活动规则，遵循诚实信用原则，不从事任何违反国家法律法规，违反活动规则或扰乱因朔桔商城平台秩序，侵害他人利益、因朔桔商城利益、公序良俗及社会公共利益的行为。</p>
          <p class="indent">5.5 若用户的行为不符合以上提到的服务条款，因朔桔商城将作出独立判断立即取消用户服务帐号。用户需对自己在网上的行为承担法律责任。用户若在因朔桔商城上散布和传播反动、色情或其他违反国家法律的信息，因朔桔商城的系统记录有可能作为用户违反法律的证据。</p>
          <p class="indent">5.6 您可在因朔桔商城上对与您达成交易的商家商品或服务进行评价。您的评价行为应遵守因朔桔商城相关规则，评价内容不应含有法律禁止和本协议禁止信息。</p>
          <p class="indent">5.7 您理解并同意：因朔桔商城有权根据用户注册登陆信息、用户行为、用户数据、海量用户数据的关系及普通人的正常消费、交易习惯、快递物流行业习惯、互联网领域行业惯例、生活常识等因素判定用户是否存在违约行为。</p>
          <p class="indent">5.8 您理解并同意：你在使用因朔桔商城平台过程中，不得进行任何侵犯因朔桔商城平台或第三方知识产权或其他权益的行为。</p>
          <p class="indent">5.9 除因朔桔商城明示的收费业务外，因朔桔商城暂时为您提供免费服务，不向您收取任何费用，但因朔桔商城保留收费的权利。</p>

          <h3>6、违约责任</h3>
          <p class="indent">6.1 如果因朔桔商城发现或收到他人举报投诉您违反本协议约定或存在任何恶意行为的，因朔桔商城有权随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁、注销、收回已发放（包含已使用及未使用）的权益或奖励等处罚，并公告处理结果。</p>
          <p class="indent">6.2 因朔桔商城有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。</p>
          <p class="indent">6.3 您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；因朔桔商城因此遭受损失的，您也应当一并赔偿。</p>
          <p class="indent">6.4 您理解并同意，当您违反以下行为中的任何一种或者多种，因朔桔商城有权采取取消违规订单、撤销活动资格、收回奖励、暂停/限制使用权益、暂停/终止使用账号等措施，且无须事先征得您的同意或提前通知您，并保留依法追究法律责任（包括但不限于民事、刑事责任）的权利：</p>
          <p class="indent">6.4.1 通过任何不正当手段或以违反诚实信用原则的方式参与活动的，如通过与其他用户串通或利用机器等方式进行作弊、利用黑客工具、恶意套现等扰乱活动秩序的行为；</p>
          <p class="indent">6.4.2 通过任何不正当手段或以违反诚实信用原则的方式达成交易的，如利用秒杀器等工具做任务或参与互动、套取优惠利差、虚假下单交易、提供虚假交易信息等扰乱交易秩序、违反交易规则的行为；</p>
          <p class="indent">6.4.3 通过恶意退货或退款获取非法利益的行为，如利用退款流程的便利性以实现获取优惠权益的目的；</p>
          <p class="indent">6.4.4 从事危及因朔桔商城、因朔桔商城合作方、其他用户等任何第三方交易安全、资金安全、账户安全的行为。</p>

          <h3>7、结束服务</h3>
          <p class="indent">7.1 用户或因朔桔商城可随时根据实际情况中断一项或多项网络服务。用户对后来的条款修改有异议，或对因朔桔商城的服务不满，可以行使如下权利：</p>
          <p class="indent">7.1.1 停止使用因朔桔商城的网络服务。</p>
          <p class="indent">7.1.2 通告因朔桔商城停止对该用户的服务。</p>
          <p class="indent">7.1.3 在满足因朔桔商城账户注销条件时注销您的账户。</p>
          <p class="indent">7.2 结束用户服务后，用户使用网络服务的权利马上中止。从那时起，因朔桔商城也没有义务传送任何未处理的信息或未完成的服务给用户或第叁方。</p>
          <p class="indent">7.3 如您违反本协议、因朔桔商城公示的平台规则、发布违禁信息、骗取勒索他人财物、采取不正当手段牟利、侵犯他人合法权益等行为的，因朔桔商城有权不经通知及时删除、屏蔽相关内容，并对您的账户进行限制部分或全部功能，或予以账户冻结。</p>
          <p class="indent">7.4 如您的账户存在被盗用、黑客攻击、干扰或经因朔桔商城分析存在其他异常的，为保护您的权益和因朔桔商城的利益，因朔桔商城有权对您的账户进行限制部分或全部功能，或予以暂时账户冻结。</p>
          <p class="indent">7.5 因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、主张或损失，您应当独立承担责任；因朔桔商城因此遭受损失的，您也应当一并赔偿。</p>

          <h3>8、通知</h3>
          <p class="indent">您在因朔桔商城平台注册/填写的联系电话、联系地址、电邮地址视为您的有效通知地址。除非另行明示载明，任何通知将发往您向因朔桔商城提供的电邮地址或者通过短信、彩信等方式发送至您向因朔桔商城提供的联系电话上。或者，因朔桔商城可通过已预付邮资和要求回执的保证航空信，将通知发往您向因朔桔商城提供或您作出相关更新的联系地址。您确认接受以上因朔桔商城使用的通知方式。任何通知应视为于以下时间送达：</p>
          <p class="indent">(a) 如通过电邮或者短信、彩信等方式发送，则电邮或者短信彩信等发送后24个小时，但发送方被告知电邮地址或者手机号码无效的，则属例外。</p>
          <p class="indent">(b) 如以预付邮资的信件发送，则投邮之日后叁个营业日。</p>

          <h3>9、广告</h3>
          <p class="indent">用户在他们发表的信息中加入宣传资料或参与广告策划，在因朔桔商城的免费服务上展示他们的产品，任何这类促销方法，包括运输货物、付款、服务、商业条件、担保及与广告有关的描述都只是在相应的用户和广告销售商之间发生。因朔桔商城不承担任何责任，因朔桔商城没有义务为这类广告销售负任何一部分的责任。同时，因朔桔商城享有对用户发表的信息进行存储、删除、分发、复制的权利。</p>

          <h3>10、版权声明</h3>
          <p class="indent">因朔桔商城定义的网络服务内容包括：文字、软件、声音、图片、录象、图表、广告中的全部内容；电子邮件的全部内容；因朔桔商城为用户提供的其他信息。所有这些内容受版权、商标、标签和其它财产所有权法律的保护。所以，用户只能在因朔桔商城和广告商授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。因朔桔商城所有的文章版权归原文作者和因朔桔商城共同所有，任何人需要转载因朔桔商城的文章，必须征得原文作者或因朔桔商城授权。</p>

          <h3>11、许可</h3>
          <p class="indent">您为使因朔桔商城能够使用您向因朔桔商城提交的资料，使因朔桔商城不违反您可能在该资料中拥有的任何权利之目的，同意向因朔桔商城授予非独占、全球性、永久、不可撤消、免使用费、可分许可(通过多层许可的方式)的权利，以行使您在您的资料(在任何已知或目前为未知媒体中)享有的与您的资料有关的著作权、发表权和数据权(但无其它权利)。因朔桔商城将根据隐私权保护规则使用您的资料。</p>

          <h3>12、有限责任与责任限制</h3>
          <p class="indent">12.1 因朔桔商城依照法律规定履行基础保障义务，但对于下述原因导致的本合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，因朔桔商城并不承担相应的违约责任：</p>
          <p class="indent">12.1.1 因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
          <p class="indent">12.1.2 因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
          <p class="indent">12.1.3 在因朔桔商城已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</p>
          <p class="indent">12.2 因朔桔商城将致力于不断提升因朔桔商城的购物体验，但鉴于网络环境下信息与实物相分离等特点，因朔桔商城无法逐一审查和核实商家上载或发布的商品及/或服务的信息，无法逐一审查交易所涉及的商品及/或服务的质量、安全以及合法性、真实性、准确性，因此，如您对选购商品或服务有任何疑问，请您谨慎判断并与商家及时沟通解决，因朔桔商城将提供协助支持。</p>
          <p class="indent">12.3 如因不可抗力或其他因朔桔商城无法控制的原因使因朔桔商城销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，因朔桔商城不承担责任。但是因朔桔商城会尽可能合理地协助处理善后事宜，并努力使客户免受经济损失。</p>
          <p class="indent">12.4 除了因朔桔商城的使用条件中规定的其它限制和除外情况之外，在中国法律法规所允许的限度内，对于因交易而引起的或与之有关的任何直接的、间接的、特殊的、附带的、后果性的或惩罚性的损害，或任何其它性质的损害，因朔桔商城、因朔桔商城的董事、管理人员、雇员、代理或其它代表在任何情况下都不承担责任。</p>

          <h3>13、用户隐私制度</h3>
          <p class="indent">因朔桔商城设有适用于所有用户并纳入用户协议的隐私权保护规则。您在作为因朔桔商城用户期间将受其规定(及因朔桔商城对隐私权保护规则作出的任何修订)的约束。</p>

          <h3>14、一般规定</h3>
          <p class="indent">14.1 本协议在所有方面均受中华人民共和国法律管辖，对于因本协议而产生的或者与本协议有关的争议，双方均应通过友好协商的方式进行解决。如协商不能解决，任何一方均应提交上海市浦东新区有管辖权的人民法院通过诉讼解决。</p>
          <p class="indent">14.2 本协议的规定是可分割的，如本协议任何规定被裁定为无效或不可执行，该规定可被删除而其余条款应予以执行。</p>
          <p class="indent">14.3 您同意，在发生并购时，本协议和所有纳入协议的条款和规则可由因朔桔商城自行酌情决定向第叁方自动转让。</p>
          <p class="indent">14.4 标题仅为参考之用，在任何方面均不界定、限制、解释或描述条款的范围或限度。标题与对应条款不一致的，以条款约定的内容为准。</p>
          <p class="indent">14.5 因朔桔商城未就您或其他方的违约采取行动并不等于因朔桔商城放弃就随后或类似的违约采取行动的权利。您同意，本协议不得仅由于系因朔桔商城制订而以对因朔桔商城不利的方式予以解释。本协议和本协议所含条款和条件载明我们双方之间就本协议标的之全部谅解和协议。</p>

          <h3>15、提供平台服务</h3>
          <p class="indent">因朔桔商城的关联企业可能通过因朔桔商城发布营销信息，我们为您提供关联企业的链接，您在点击该链接后会跳转至对应关联企业的网站，后续将由该关联企业为您提供服务或者销售产品。您在接受其服务或者购买产品前，应仔细阅读它们自己的隐私政策及使用条件。</p>
        </div>
      </div>
    </div>
    <FooterLayout />
  </div>
</template>

<script>
import HeaderLayout from '@/components/pc/HeaderLayout.vue'
import FooterLayout from '@/components/pc/FooterLayout.vue'

export default {
  name: 'UserAgreement',
  components: {
    HeaderLayout,
    FooterLayout
  }
}
</script>

<style lang="scss" scoped>
.user-agreement {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;

  .agreement-container {
    flex: 1;
    width: 1200px;
    margin: 30px auto;
    background: #fff;
    padding: 40px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    .agreement-title {
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 30px;
    }

    .agreement-content {
      .content-main {
        font-size: 14px;
        line-height: 1.8;
        color: #333;
        text-align: left;

        p {
          margin: 14px 0;
          text-indent: 2em;

          strong {
            font-weight: bold;
            display: block;
            text-indent: 0;
            margin: 20px 0 10px;
          }
        }
      }
    }
  }
}
</style>
